// What makes a contract complete (US 9371): the contract hero's ring and the child header on the third-party page (US 9369 + 9371)
export function contractChecks(contract, client) {
  let owner = (contract.users || []).find(user => user.owner);
  let checks = [
    { key: 'third_party', ok: (contract.vendors || []).length > 0 },
    { key: 'owner', ok: !!owner },
    { key: 'description', ok: !!contract.description }
  ];
  // The privacy facts only count where the GDPR module and the contract's data privacy part are on
  if (client.gdprModule && contract.data_privacy_feature) {
    checks.push({ key: 'dpa', ok: !!contract.data_processor_agreement });
    checks.push({ key: 'locations', ok: !!(contract.processing_locations && contract.processing_locations.length) });
    checks.push({ key: 'transfers', ok: !!contract.transfers_disclosures_third_countries });
  }
  return checks;
}
